import { gql } from '@apollo/client';

export const GET_QUIZ_ATTEMPT = gql`
  query GetQuizAttempt($attemptId: ID!) {
    getQuizAttempt(attemptId: $attemptId) {
      _id
      sport
      type
      level
      scorePercent
      passed
      gScore
      dateTaken
      traitScores
      profile
      confidence
      blend
      questions {
        questionText
        correctAnswer
        userAnswer
        correct
      }
    }
  }
`;
//may need to add ETSTraitScores if still including it